import { ElementRef, Renderer2 } from '@angular/core';
import { Utils } from 'sharedFeatures/utils';
import { BrowserDetectUtil } from 'sharedGuiSmall/utils/browser-detect-util';

export class BaseComponent {

    constructor(private el: ElementRef, protected r: Renderer2) {

        if (BrowserDetectUtil.isIe() && this.r) this.r.addClass(this.getElDom(), 'ie');

        if (BrowserDetectUtil.isMac()) this.r.addClass(this.getElDom(), 'mac');

        if (BrowserDetectUtil.isFirefox()) this.r.addClass(this.getElDom(), 'firefox');

    }

    getElDom(): HTMLElement {

        return this.el.nativeElement;

    }

    public getZIndex(): number | undefined {

        return Utils.getZIndex(this.getElDom());

    }

    get visibleOnPage() {
        const el = this.getElDom();
        return el.offsetHeight != 0 && el.offsetWidth != 0 && getComputedStyle(el).display != 'none';
    }
}
